export const MODULES = [
  { key: "pending_jobs", label: "Pending Jobs" },
  { key: "dashboard", label: "Dashboard" },
  { key: "customers", label: "Customers" },
  { key: "customer_info", label: "Customer Info" },
  { key: "interactions", label: "Interactions" },
  { key: "assets", label: "Assets" },
  { key: "support_tickets", label: "Support Tickets" },
  { key: "toner_management", label: "Toner Management" },
  { key: "teamviewer", label: "Teamviewer" },
  { key: "employee", label: "Employee" },
  { key: "knowledge_base", label: "OTS KB" },
  { key: "client_billing", label: "Client Billing" },
  { key: "projects", label: "Projects" },
  { key: "reports", label: "Reports" },
  { key: "users", label: "Users" },
  { key: "smtp_settings", label: "SMTP Settings" },
];

export const PERMISSION_LEVELS = [
  { value: "none", label: "None" },
  { value: "view", label: "View" },
  { value: "edit", label: "Edit" },
];

const STAFF_NO_ACCESS = ["client_billing", "projects", "reports", "users", "smtp_settings"];

export const roleDefaults = (role) => {
  const map = {};
  MODULES.forEach(({ key }) => {
    map[key] = role === "admin" ? "edit" : STAFF_NO_ACCESS.includes(key) ? "none" : "edit";
  });
  return map;
};

export const getEffectivePermissions = (user) => {
  if (!user) return {};
  if (user.is_super_admin) {
    const all = {};
    MODULES.forEach(({ key }) => (all[key] = "edit"));
    return all;
  }
  if (user.effective_permissions && Object.keys(user.effective_permissions).length > 0) {
    return user.effective_permissions;
  }
  const base = roleDefaults(user.role);
  Object.entries(user.permissions || {}).forEach(([k, v]) => {
    if (k in base) base[k] = v;
  });
  return base;
};
